<template>
  <div class="editor"></div>
</template>

<script>
import E from 'wangeditor'
import axios from 'axios'
export default {
  props: {
    defalutContent: String,
    editorHeight: {
      typy: Number,
      default: 300,
    },
  },
  data() {
    return {
      editor: null,
    }
  },
  computed: {
    action() {
      return process.env.NODE_ENV === 'development'
        ? '/upload/save'
        : '/upload/save'
    },
  },
  watch: {
    defalutContent(val) {
      this.init(val)
    },
  },
  methods: {
    init(val) {
      this.editor.txt.html(val)
    },
    append(val) {
      this.editor.txt.append(val)
    },
    clear() {
      this.editor.txt.clear()
    },
    change(val) {
      this.$emit('on-change', val)
    },
    async uploadFile(resultFiles, insertImgFn) {
      for (const file of resultFiles) {
        let formData = new FormData()
        formData.append('file', file, file.name)
        let res = await axios.post(this.action, formData)
        if (res.success) {
          let fileData = res.data[0]
          let imgUrl = fileData.url
          insertImgFn(imgUrl)
        } else {
          this.$Message.error('上传失败')
        }
      }
    },
  },
  mounted() {
    /* eslint-disable no-new */
    this.editor = new E('.editor')
    this.editor.config.uploadImgShowBase64 = true
    this.editor.config.onchange = this.change
    this.editor.config.height = this.editorHeight
    this.editor.config.zIndex = 500
    this.editor.create()
    this.init(this.defalutContent)
    this.editor.config.customUploadImg = this.uploadFile
    this.editor.config.customUploadVideo = this.uploadFile
  },
}
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// src/components/TextEditor.vue